<template>
  <div>
    <div class="opc-plan__bought-license" v-if="displayCount">
      <span>{{ $t('billing.prorated.cur_users', [displayCount, unit]) }}</span>
      <span class="opc-plan__bought-license-extra-info" v-if="showExtraInfo"> {{ this.extraInfo }} </span>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { getPlanUnitByQuantity } from '@/common/product-unit';
import mx from './mx.vue';
export default {
  props: {
    value: Number,
    showExtraInfo: {
      type: Boolean,
      default: false,
    },
    customUnit: String,
    extraInfo: String,
  },
  mixins: [mx],
  computed: {
    displayCount() {
      if (this.mx_boughtPlan?.category !== this.mx_cartPlan.category) return "";
      return `${this.mx_boughtPlan?.cartInfo?.selected_number ?? ''}`;
    },
    unit() {
      return this.customUnit || getPlanUnitByQuantity(this.mx_boughtPlan?.unit, this.mx_boughtPlan?.cartInfo?.selected_number);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils.scss';

.opc-plan__bought-license {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 0;
  text-align: left;
  color: var(--zoom-color-text-neutral, #686F79);

  @include simplifyStyle() {
    padding: 0;
  }

  &-extra-info {
    margin-left: 4px;
  }
}
</style>
